import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
  [ModulesConfigMap[ModulesMap.REPORTS_FINANCE_BY_MATERIALS_CATEGORIES].GET_REPORTS_FINANCE_BY_MATERIALS_CATEGORIES]: {
    url: '/company/:companyId/reports/finance/by_materials_categories/',
  },
}